export class Step6 {
    constructor() {}

    getautrerenseignement = 'form.dive_in.getautresrenseignements';
    gettextelibre = 'form.dive_in.gettextelibre';
    getintitulelibre = 'form.dive_in.getintitulelibre';
    getintitulelibrelibelle = 'form.dive_in.getintitulelibrelibelle';

}
